import type { SVGProps } from 'react'

export default function HeroGlyphCircle(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M39.1431 22C39.1431 12.5323 31.468 4.85715 22.0003 4.85715C12.5325 4.85715 4.85742 12.5323 4.85742 22C4.85742 31.4677 12.5325 39.1428 22.0003 39.1428C31.468 39.1428 39.1431 31.4677 39.1431 22Z"
				stroke="#3D1B3C"
				strokeWidth="5.71429"
			/>
		</svg>
	)
}
